import { render } from "./MarginsByProduct.vue?vue&type=template&id=2f3a340d"
import script from "./MarginsByProduct.vue?vue&type=script&lang=ts"
export * from "./MarginsByProduct.vue?vue&type=script&lang=ts"
script.render = render

export default script